import React  from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Container } from 'reactstrap';
import { Icon } from '@iconify/react';
import { useDispatch } from "react-redux";
import { logout } from "../../../../actions/customer";
import Swal from "sweetalert2";
const DashboardContent = ({ onLogout }) => {
  const dispatch = useDispatch();

  const handleLogoutClick = (e) => {
    e.preventDefault();
    
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to logout from your account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout!",
      cancelButtonText: "Cancel",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout()); // ✅ FIXED
      }
    });
  };
  return (
<div className="dashboard-wrapper py-4">
  <Container>
    <Row className="g-4">

      {/* 0. Dashboard (NEW - Explore Jobs se pehle) */}
      <Col xl={4} md={6} xs={12}>
        <Link to="/candidate/dashboard" className="dashboard-card-item">
          <div className="card-icon-wrapper">
            <Icon icon="mdi:view-dashboard-outline" className="card-icon" />
          </div>
          <div className="card-text-content">
            <span className="card-title-text">Dashboard</span>
          </div>
        </Link>
      </Col>

      {/* 1. Explore Jobs */}
      <Col xl={4} md={6} xs={12}>
        <Link to="/jobs" className="dashboard-card-item">
          <div className="card-icon-wrapper">
            <Icon icon="akar-icons:paper" className="card-icon" />
          </div>
          <div className="card-text-content">
            <span className="card-title-text">Explore Jobs</span>
          </div>
        </Link>
      </Col>

      {/* 2. Manage Job Applications */}
      <Col xl={4} md={6} xs={12}>
        <Link
          to="/candidate/job/application/manage"
          className="dashboard-card-item"
        >
          <div className="card-icon-wrapper">
            <Icon icon="mdi:file-document-check-outline" className="card-icon" />
          </div>
          <div className="card-text-content">
            <span className="card-title-text">
              Manage Job Applications
            </span>
          </div>
        </Link>
      </Col>

      {/* 3. Bookmarked Jobs */}
      <Col xl={4} md={6} xs={12}>
        <Link
          to="/candidate/job/bookmark/manage"
          className="dashboard-card-item"
        >
          <div className="card-icon-wrapper">
            <Icon icon="bi:bookmark-check" className="card-icon" />
          </div>
          <div className="card-text-content">
            <span className="card-title-text">
              Bookmarked Jobs
            </span>
          </div>
        </Link>
      </Col>

      {/* 4. My Profile */}
      <Col xl={4} md={6} xs={12}>
        <Link
          to="/candidate/profile/view"
          className="dashboard-card-item"
        >
          <div className="card-icon-wrapper">
            <Icon icon="iconoir:profile-circled" className="card-icon" />
          </div>
          <div className="card-text-content">
            <span className="card-title-text">
              My Profile
            </span>
          </div>
        </Link>
      </Col>

      {/* 5. Logout */}
      <Col xl={4} md={6} xs={12}>
        <Link
          to="/"
          onClick={handleLogoutClick}
          className="dashboard-card-item card-logout-variant"
        >
          <div className="card-icon-wrapper">
            <Icon icon="akar-icons:sign-out" className="card-icon" />
          </div>
          <div className="card-text-content">
            <span className="card-title-text">
              Log Out
            </span>
          </div>
        </Link>
      </Col>

    </Row>
  </Container>
</div>
  )
}

export default DashboardContent